export default __webpack_public_path__ + "static/media/onboarding_guide_2.12ec8eed.png";